<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { UiSortMenu } from '@/components';
import type { SortMenuItem } from '@/types';

const props = defineProps<{ modelValue: SortMenuItem[] }>();
const emit = defineEmits<{ 'update:modelValue': [SortMenuItem[]] }>();
const { t } = useI18n();

const items = ref<SortMenuItem[]>([
    { label: t('aura.processingCosts.sort.startedAt'), key: 'startedAt' },
    { label: t('aura.processingCosts.sort.costUsd'), key: 'costUsd' },
    { label: t('aura.processingCosts.sort.tokensUsed'), key: 'tokensUsed' },
]);
</script>

<template>
    <UiSortMenu
        :items="items"
        :model-value="props.modelValue"
        fixmobile
        @update:model-value="emit('update:modelValue', $event)"
    />
</template>
